import { render, staticRenderFns } from "./Piechart.vue?vue&type=template&id=395ea97b&"
import script from "./Piechart.vue?vue&type=script&lang=js&"
export * from "./Piechart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports